import { BookingForm } from "@/components/BookingForm";
import { BRAND, LOGO } from "@/lib/brand";

export default function EmbedBooking() {
  return (
    <div className="min-h-screen bg-[#FAF8F5] p-4 sm:p-8" data-testid="embed-booking-page">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center justify-between gap-4 mb-6">
          <img src={LOGO} alt={BRAND.name} className="h-10 w-auto" />
          <a href={BRAND.phoneHref} className="text-sm font-semibold text-[#0D3B52]">{BRAND.phone}</a>
        </div>
        <div className="rounded-3xl bg-white border border-[#E2DDD5] p-6 sm:p-8">
          <h1 className="font-display text-3xl font-semibold text-[#0D3B52] mb-6">Prenota un ritiro</h1>
          <BookingForm mode="public" />
        </div>
      </div>
    </div>
  );
}
